import { $headerNavigationMobileSlider } from './_slider';

const initHeaderHamburger = function () {
	// Header menu button ( Hamburger )
	$('.ren-lnav__opener').on('click', function () {
		// During slider initialization container has width == 0 and slides also have width == 0
		// So we fix this by refresh slider when menu opens
		if (!$('body').hasClass('ren-header-topnav-opened')) {
			$headerNavigationMobileSlider.slick('refresh');
		}
		$('body').toggleClass('ren-header-topnav-opened');
	});
};

export default initHeaderHamburger;
